import { httpsCallable } from 'firebase/functions';
import { FirebaseError } from 'firebase/app';
import { useAppDispatch, useAppSelector } from '../../../../../hooks';
import { functions } from '../../../../../config/firebase';
import {
    fetchLinksStart,
    fetchLinksSuccess,
    fetchLinksFailure,
    clearLinksError,
} from '../slice/whatsappLinksSlice';
import { ResponseWhatsappLinksInterface } from '../../domain/interfaces/WhatsappLinkInterface';

const useWhatsappLinkInfrastructure = () => {
    const dispatch = useAppDispatch();
    const whatsappLinksState = useAppSelector((state) => state.whatsappLinks);

    const getWhatsappLinksCallable = httpsCallable<void, ResponseWhatsappLinksInterface>(functions, 'getWhatsappLinks');

    const fetchLinksInfrastructure = async () => {
        dispatch(fetchLinksStart());
        try {
            const result = await getWhatsappLinksCallable();
            dispatch(fetchLinksSuccess(result.data.data));
        } catch (error) {
            const errorMessage = error instanceof FirebaseError ? error.message : 'Ocurrió un error inesperado.';
            dispatch(fetchLinksFailure(errorMessage));
        }
    };

    const clearErrorInfrastructure = () => {
        dispatch(clearLinksError());
    };

    return { fetchLinksInfrastructure, clearErrorInfrastructure, whatsappLinksState };
};

export default useWhatsappLinkInfrastructure;

